/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.TransportFinanceDetailReportResponseDto>
>;
export function request(
  params: API.tms.transportFinanceDetail.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportFinanceDetail/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
